/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Role } from './role';
import { User } from './user';

export interface Project { 
    id?: number;
    name?: string;
    buildingPlace?: string;
    plotNumber?: string;
    projectKind?: Project.ProjectKindEnum;
    beginPlanning?: Date;
    endPlanning?: Date;
    startExecuting?: Date;
    endExecuting?: Date;
    street?: string;
    zipCode?: string;
    houseNumber?: string;
    latitude?: number;
    longitude?: number;
    country?: Project.CountryEnum;
    progress?: number;
    quality?: number;
    software?: string;
    state?: Project.StateEnum;
    projectIdIntern?: string;
    isBIM?: boolean;
    projectManager?: User;
    buildingApplication?: string;
    image?: string;
    hasImage?: boolean;
    qualitySettings?: string;
    creator?: User;
    fileSize?: number;
    numberOfFiles?: number;
    qualityCheckCount?: number;
    ifcCheckCount?: number;
    workflowCheckCount?: number;
    builderTitle?: Project.BuilderTitleEnum;
    builderSalutation?: Project.BuilderSalutationEnum;
    builderFirstName?: string;
    builderLastName?: string;
    builderStreet?: string;
    builderHouseNumber?: string;
    builderZipCode?: string;
    builderCity?: string;
    builderState?: Project.BuilderStateEnum;
    builderCountry?: Project.BuilderCountryEnum;
    users?: Array<User>;
    ownerProfilImage?: string;
    organisationProject?: boolean;
    checksAmount?: number;
    owner?: string;
    customRoles?: Array<Role>;
    roles?: Array<Role>;
}
export namespace Project {
    export type ProjectKindEnum = 'WOHNEN' | 'AUSBILDUNG_WISSENSCHAFT_FORSCHUNG' | 'BUERO_VERWALTUNG_STAAT_KOMMUNE' | 'GESUNDHEIT_BETREUUNG' | 'HANDEL_UND_VERKAUF_GASTGEWERBE' | 'FREIZEIT_SPORT' | 'GEWERBE_INDUSTRIE_LANDWIRTSCHAFT' | 'INFRASTRUKTUR' | 'KULTUR_UND_SAKRALES';
    export const ProjectKindEnum = {
        WOHNEN: 'WOHNEN' as ProjectKindEnum,
        AUSBILDUNGWISSENSCHAFTFORSCHUNG: 'AUSBILDUNG_WISSENSCHAFT_FORSCHUNG' as ProjectKindEnum,
        BUEROVERWALTUNGSTAATKOMMUNE: 'BUERO_VERWALTUNG_STAAT_KOMMUNE' as ProjectKindEnum,
        GESUNDHEITBETREUUNG: 'GESUNDHEIT_BETREUUNG' as ProjectKindEnum,
        HANDELUNDVERKAUFGASTGEWERBE: 'HANDEL_UND_VERKAUF_GASTGEWERBE' as ProjectKindEnum,
        FREIZEITSPORT: 'FREIZEIT_SPORT' as ProjectKindEnum,
        GEWERBEINDUSTRIELANDWIRTSCHAFT: 'GEWERBE_INDUSTRIE_LANDWIRTSCHAFT' as ProjectKindEnum,
        INFRASTRUKTUR: 'INFRASTRUKTUR' as ProjectKindEnum,
        KULTURUNDSAKRALES: 'KULTUR_UND_SAKRALES' as ProjectKindEnum
    };
    export type CountryEnum = 'AND' | 'ARE' | 'AFG' | 'ATG' | 'AIA' | 'ALB' | 'ARM' | 'AGO' | 'ATA' | 'ARG' | 'ASM' | 'AUT' | 'AUS' | 'ABW' | 'ALA' | 'AZE' | 'BIH' | 'BRB' | 'BGD' | 'BEL' | 'BFA' | 'BGR' | 'BHR' | 'BDI' | 'BEN' | 'BLM' | 'BMU' | 'BRN' | 'BOL' | 'BES' | 'BRA' | 'BHS' | 'BTN' | 'BVT' | 'BWA' | 'BLR' | 'BLZ' | 'CAN' | 'CCK' | 'COD' | 'CAF' | 'COG' | 'CHE' | 'CIV' | 'COK' | 'CHL' | 'CMR' | 'CHN' | 'COL' | 'CRI' | 'CUB' | 'CPV' | 'CUW' | 'CXR' | 'CYP' | 'CZE' | 'DEU' | 'DJI' | 'DNK' | 'DMA' | 'DOM' | 'DZA' | 'ECU' | 'EST' | 'EGY' | 'ESH' | 'ERI' | 'ESP' | 'ETH' | 'FIN' | 'FJI' | 'FLK' | 'FSM' | 'FRO' | 'FRA' | 'GAB' | 'GBR' | 'GRD' | 'GEO' | 'GUF' | 'GGY' | 'GHA' | 'GIB' | 'GRL' | 'GMB' | 'GIN' | 'GLP' | 'GNQ' | 'GRC' | 'SGS' | 'GTM' | 'GUM' | 'GNB' | 'GUY' | 'HKG' | 'HMD' | 'HND' | 'HRV' | 'HTI' | 'HUN' | 'IDN' | 'IRL' | 'ISR' | 'IMN' | 'IND' | 'IOT' | 'IRQ' | 'IRN' | 'ISL' | 'ITA' | 'JEY' | 'JAM' | 'JOR' | 'JPN' | 'KEN' | 'KGZ' | 'KHM' | 'KIR' | 'COM' | 'KNA' | 'PRK' | 'KOR' | 'KWT' | 'CYM' | 'KAZ' | 'LAO' | 'LBN' | 'LCA' | 'LIE' | 'LKA' | 'LBR' | 'LSO' | 'LTU' | 'LUX' | 'LVA' | 'LBY' | 'MAR' | 'MCO' | 'MDA' | 'MNE' | 'MAF' | 'MDG' | 'MHL' | 'MKD' | 'MLI' | 'MMR' | 'MNG' | 'MAC' | 'MNP' | 'MTQ' | 'MRT' | 'MSR' | 'MLT' | 'MUS' | 'MDV' | 'MWI' | 'MEX' | 'MYS' | 'MOZ' | 'NAM' | 'NCL' | 'NER' | 'NFK' | 'NGA' | 'NIC' | 'NLD' | 'NOR' | 'NPL' | 'NRU' | 'NIU' | 'NZL' | 'OMN' | 'PAN' | 'PER' | 'PYF' | 'PNG' | 'PHL' | 'PAK' | 'POL' | 'SPM' | 'PCN' | 'PRI' | 'PSE' | 'PRT' | 'PLW' | 'PRY' | 'QAT' | 'REU' | 'ROU' | 'SRB' | 'RUS' | 'RWA' | 'SAU' | 'SLB' | 'SYC' | 'SDN' | 'SWE' | 'SGP' | 'SHN' | 'SVN' | 'SJM' | 'SVK' | 'SLE' | 'SMR' | 'SEN' | 'SOM' | 'SUR' | 'SSD' | 'STP' | 'SLV' | 'SXM' | 'SYR' | 'SWZ' | 'TCA' | 'TCD' | 'ATF' | 'TGO' | 'THA' | 'TJK' | 'TKL' | 'TLS' | 'TKM' | 'TUN' | 'TON' | 'TUR' | 'TTO' | 'TUV' | 'TWN' | 'TZA' | 'UKR' | 'UGA' | 'UMI' | 'USA' | 'URY' | 'UZB' | 'VAT' | 'VCT' | 'VEN' | 'VGB' | 'VIR' | 'VNM' | 'VUT' | 'WLF' | 'WSM' | 'YEM' | 'MYT' | 'ZAF' | 'ZMB' | 'ZWE';
    export const CountryEnum = {
        AND: 'AND' as CountryEnum,
        ARE: 'ARE' as CountryEnum,
        AFG: 'AFG' as CountryEnum,
        ATG: 'ATG' as CountryEnum,
        AIA: 'AIA' as CountryEnum,
        ALB: 'ALB' as CountryEnum,
        ARM: 'ARM' as CountryEnum,
        AGO: 'AGO' as CountryEnum,
        ATA: 'ATA' as CountryEnum,
        ARG: 'ARG' as CountryEnum,
        ASM: 'ASM' as CountryEnum,
        AUT: 'AUT' as CountryEnum,
        AUS: 'AUS' as CountryEnum,
        ABW: 'ABW' as CountryEnum,
        ALA: 'ALA' as CountryEnum,
        AZE: 'AZE' as CountryEnum,
        BIH: 'BIH' as CountryEnum,
        BRB: 'BRB' as CountryEnum,
        BGD: 'BGD' as CountryEnum,
        BEL: 'BEL' as CountryEnum,
        BFA: 'BFA' as CountryEnum,
        BGR: 'BGR' as CountryEnum,
        BHR: 'BHR' as CountryEnum,
        BDI: 'BDI' as CountryEnum,
        BEN: 'BEN' as CountryEnum,
        BLM: 'BLM' as CountryEnum,
        BMU: 'BMU' as CountryEnum,
        BRN: 'BRN' as CountryEnum,
        BOL: 'BOL' as CountryEnum,
        BES: 'BES' as CountryEnum,
        BRA: 'BRA' as CountryEnum,
        BHS: 'BHS' as CountryEnum,
        BTN: 'BTN' as CountryEnum,
        BVT: 'BVT' as CountryEnum,
        BWA: 'BWA' as CountryEnum,
        BLR: 'BLR' as CountryEnum,
        BLZ: 'BLZ' as CountryEnum,
        CAN: 'CAN' as CountryEnum,
        CCK: 'CCK' as CountryEnum,
        COD: 'COD' as CountryEnum,
        CAF: 'CAF' as CountryEnum,
        COG: 'COG' as CountryEnum,
        CHE: 'CHE' as CountryEnum,
        CIV: 'CIV' as CountryEnum,
        COK: 'COK' as CountryEnum,
        CHL: 'CHL' as CountryEnum,
        CMR: 'CMR' as CountryEnum,
        CHN: 'CHN' as CountryEnum,
        COL: 'COL' as CountryEnum,
        CRI: 'CRI' as CountryEnum,
        CUB: 'CUB' as CountryEnum,
        CPV: 'CPV' as CountryEnum,
        CUW: 'CUW' as CountryEnum,
        CXR: 'CXR' as CountryEnum,
        CYP: 'CYP' as CountryEnum,
        CZE: 'CZE' as CountryEnum,
        DEU: 'DEU' as CountryEnum,
        DJI: 'DJI' as CountryEnum,
        DNK: 'DNK' as CountryEnum,
        DMA: 'DMA' as CountryEnum,
        DOM: 'DOM' as CountryEnum,
        DZA: 'DZA' as CountryEnum,
        ECU: 'ECU' as CountryEnum,
        EST: 'EST' as CountryEnum,
        EGY: 'EGY' as CountryEnum,
        ESH: 'ESH' as CountryEnum,
        ERI: 'ERI' as CountryEnum,
        ESP: 'ESP' as CountryEnum,
        ETH: 'ETH' as CountryEnum,
        FIN: 'FIN' as CountryEnum,
        FJI: 'FJI' as CountryEnum,
        FLK: 'FLK' as CountryEnum,
        FSM: 'FSM' as CountryEnum,
        FRO: 'FRO' as CountryEnum,
        FRA: 'FRA' as CountryEnum,
        GAB: 'GAB' as CountryEnum,
        GBR: 'GBR' as CountryEnum,
        GRD: 'GRD' as CountryEnum,
        GEO: 'GEO' as CountryEnum,
        GUF: 'GUF' as CountryEnum,
        GGY: 'GGY' as CountryEnum,
        GHA: 'GHA' as CountryEnum,
        GIB: 'GIB' as CountryEnum,
        GRL: 'GRL' as CountryEnum,
        GMB: 'GMB' as CountryEnum,
        GIN: 'GIN' as CountryEnum,
        GLP: 'GLP' as CountryEnum,
        GNQ: 'GNQ' as CountryEnum,
        GRC: 'GRC' as CountryEnum,
        SGS: 'SGS' as CountryEnum,
        GTM: 'GTM' as CountryEnum,
        GUM: 'GUM' as CountryEnum,
        GNB: 'GNB' as CountryEnum,
        GUY: 'GUY' as CountryEnum,
        HKG: 'HKG' as CountryEnum,
        HMD: 'HMD' as CountryEnum,
        HND: 'HND' as CountryEnum,
        HRV: 'HRV' as CountryEnum,
        HTI: 'HTI' as CountryEnum,
        HUN: 'HUN' as CountryEnum,
        IDN: 'IDN' as CountryEnum,
        IRL: 'IRL' as CountryEnum,
        ISR: 'ISR' as CountryEnum,
        IMN: 'IMN' as CountryEnum,
        IND: 'IND' as CountryEnum,
        IOT: 'IOT' as CountryEnum,
        IRQ: 'IRQ' as CountryEnum,
        IRN: 'IRN' as CountryEnum,
        ISL: 'ISL' as CountryEnum,
        ITA: 'ITA' as CountryEnum,
        JEY: 'JEY' as CountryEnum,
        JAM: 'JAM' as CountryEnum,
        JOR: 'JOR' as CountryEnum,
        JPN: 'JPN' as CountryEnum,
        KEN: 'KEN' as CountryEnum,
        KGZ: 'KGZ' as CountryEnum,
        KHM: 'KHM' as CountryEnum,
        KIR: 'KIR' as CountryEnum,
        COM: 'COM' as CountryEnum,
        KNA: 'KNA' as CountryEnum,
        PRK: 'PRK' as CountryEnum,
        KOR: 'KOR' as CountryEnum,
        KWT: 'KWT' as CountryEnum,
        CYM: 'CYM' as CountryEnum,
        KAZ: 'KAZ' as CountryEnum,
        LAO: 'LAO' as CountryEnum,
        LBN: 'LBN' as CountryEnum,
        LCA: 'LCA' as CountryEnum,
        LIE: 'LIE' as CountryEnum,
        LKA: 'LKA' as CountryEnum,
        LBR: 'LBR' as CountryEnum,
        LSO: 'LSO' as CountryEnum,
        LTU: 'LTU' as CountryEnum,
        LUX: 'LUX' as CountryEnum,
        LVA: 'LVA' as CountryEnum,
        LBY: 'LBY' as CountryEnum,
        MAR: 'MAR' as CountryEnum,
        MCO: 'MCO' as CountryEnum,
        MDA: 'MDA' as CountryEnum,
        MNE: 'MNE' as CountryEnum,
        MAF: 'MAF' as CountryEnum,
        MDG: 'MDG' as CountryEnum,
        MHL: 'MHL' as CountryEnum,
        MKD: 'MKD' as CountryEnum,
        MLI: 'MLI' as CountryEnum,
        MMR: 'MMR' as CountryEnum,
        MNG: 'MNG' as CountryEnum,
        MAC: 'MAC' as CountryEnum,
        MNP: 'MNP' as CountryEnum,
        MTQ: 'MTQ' as CountryEnum,
        MRT: 'MRT' as CountryEnum,
        MSR: 'MSR' as CountryEnum,
        MLT: 'MLT' as CountryEnum,
        MUS: 'MUS' as CountryEnum,
        MDV: 'MDV' as CountryEnum,
        MWI: 'MWI' as CountryEnum,
        MEX: 'MEX' as CountryEnum,
        MYS: 'MYS' as CountryEnum,
        MOZ: 'MOZ' as CountryEnum,
        NAM: 'NAM' as CountryEnum,
        NCL: 'NCL' as CountryEnum,
        NER: 'NER' as CountryEnum,
        NFK: 'NFK' as CountryEnum,
        NGA: 'NGA' as CountryEnum,
        NIC: 'NIC' as CountryEnum,
        NLD: 'NLD' as CountryEnum,
        NOR: 'NOR' as CountryEnum,
        NPL: 'NPL' as CountryEnum,
        NRU: 'NRU' as CountryEnum,
        NIU: 'NIU' as CountryEnum,
        NZL: 'NZL' as CountryEnum,
        OMN: 'OMN' as CountryEnum,
        PAN: 'PAN' as CountryEnum,
        PER: 'PER' as CountryEnum,
        PYF: 'PYF' as CountryEnum,
        PNG: 'PNG' as CountryEnum,
        PHL: 'PHL' as CountryEnum,
        PAK: 'PAK' as CountryEnum,
        POL: 'POL' as CountryEnum,
        SPM: 'SPM' as CountryEnum,
        PCN: 'PCN' as CountryEnum,
        PRI: 'PRI' as CountryEnum,
        PSE: 'PSE' as CountryEnum,
        PRT: 'PRT' as CountryEnum,
        PLW: 'PLW' as CountryEnum,
        PRY: 'PRY' as CountryEnum,
        QAT: 'QAT' as CountryEnum,
        REU: 'REU' as CountryEnum,
        ROU: 'ROU' as CountryEnum,
        SRB: 'SRB' as CountryEnum,
        RUS: 'RUS' as CountryEnum,
        RWA: 'RWA' as CountryEnum,
        SAU: 'SAU' as CountryEnum,
        SLB: 'SLB' as CountryEnum,
        SYC: 'SYC' as CountryEnum,
        SDN: 'SDN' as CountryEnum,
        SWE: 'SWE' as CountryEnum,
        SGP: 'SGP' as CountryEnum,
        SHN: 'SHN' as CountryEnum,
        SVN: 'SVN' as CountryEnum,
        SJM: 'SJM' as CountryEnum,
        SVK: 'SVK' as CountryEnum,
        SLE: 'SLE' as CountryEnum,
        SMR: 'SMR' as CountryEnum,
        SEN: 'SEN' as CountryEnum,
        SOM: 'SOM' as CountryEnum,
        SUR: 'SUR' as CountryEnum,
        SSD: 'SSD' as CountryEnum,
        STP: 'STP' as CountryEnum,
        SLV: 'SLV' as CountryEnum,
        SXM: 'SXM' as CountryEnum,
        SYR: 'SYR' as CountryEnum,
        SWZ: 'SWZ' as CountryEnum,
        TCA: 'TCA' as CountryEnum,
        TCD: 'TCD' as CountryEnum,
        ATF: 'ATF' as CountryEnum,
        TGO: 'TGO' as CountryEnum,
        THA: 'THA' as CountryEnum,
        TJK: 'TJK' as CountryEnum,
        TKL: 'TKL' as CountryEnum,
        TLS: 'TLS' as CountryEnum,
        TKM: 'TKM' as CountryEnum,
        TUN: 'TUN' as CountryEnum,
        TON: 'TON' as CountryEnum,
        TUR: 'TUR' as CountryEnum,
        TTO: 'TTO' as CountryEnum,
        TUV: 'TUV' as CountryEnum,
        TWN: 'TWN' as CountryEnum,
        TZA: 'TZA' as CountryEnum,
        UKR: 'UKR' as CountryEnum,
        UGA: 'UGA' as CountryEnum,
        UMI: 'UMI' as CountryEnum,
        USA: 'USA' as CountryEnum,
        URY: 'URY' as CountryEnum,
        UZB: 'UZB' as CountryEnum,
        VAT: 'VAT' as CountryEnum,
        VCT: 'VCT' as CountryEnum,
        VEN: 'VEN' as CountryEnum,
        VGB: 'VGB' as CountryEnum,
        VIR: 'VIR' as CountryEnum,
        VNM: 'VNM' as CountryEnum,
        VUT: 'VUT' as CountryEnum,
        WLF: 'WLF' as CountryEnum,
        WSM: 'WSM' as CountryEnum,
        YEM: 'YEM' as CountryEnum,
        MYT: 'MYT' as CountryEnum,
        ZAF: 'ZAF' as CountryEnum,
        ZMB: 'ZMB' as CountryEnum,
        ZWE: 'ZWE' as CountryEnum
    };
    export type StateEnum = 'BW' | 'BY' | 'BE' | 'BB' | 'HB' | 'HH' | 'HE' | 'MV' | 'NI' | 'NW' | 'RP' | 'SL' | 'SN' | 'ST' | 'SH' | 'TH';
    export const StateEnum = {
        BW: 'BW' as StateEnum,
        BY: 'BY' as StateEnum,
        BE: 'BE' as StateEnum,
        BB: 'BB' as StateEnum,
        HB: 'HB' as StateEnum,
        HH: 'HH' as StateEnum,
        HE: 'HE' as StateEnum,
        MV: 'MV' as StateEnum,
        NI: 'NI' as StateEnum,
        NW: 'NW' as StateEnum,
        RP: 'RP' as StateEnum,
        SL: 'SL' as StateEnum,
        SN: 'SN' as StateEnum,
        ST: 'ST' as StateEnum,
        SH: 'SH' as StateEnum,
        TH: 'TH' as StateEnum
    };
    export type BuilderTitleEnum = 'PROF' | 'PROF_DR' | 'DR' | 'NONE';
    export const BuilderTitleEnum = {
        PROF: 'PROF' as BuilderTitleEnum,
        PROFDR: 'PROF_DR' as BuilderTitleEnum,
        DR: 'DR' as BuilderTitleEnum,
        NONE: 'NONE' as BuilderTitleEnum
    };
    export type BuilderSalutationEnum = 'HERR' | 'FRAU' | 'NONE';
    export const BuilderSalutationEnum = {
        HERR: 'HERR' as BuilderSalutationEnum,
        FRAU: 'FRAU' as BuilderSalutationEnum,
        NONE: 'NONE' as BuilderSalutationEnum
    };
    export type BuilderStateEnum = 'BW' | 'BY' | 'BE' | 'BB' | 'HB' | 'HH' | 'HE' | 'MV' | 'NI' | 'NW' | 'RP' | 'SL' | 'SN' | 'ST' | 'SH' | 'TH';
    export const BuilderStateEnum = {
        BW: 'BW' as BuilderStateEnum,
        BY: 'BY' as BuilderStateEnum,
        BE: 'BE' as BuilderStateEnum,
        BB: 'BB' as BuilderStateEnum,
        HB: 'HB' as BuilderStateEnum,
        HH: 'HH' as BuilderStateEnum,
        HE: 'HE' as BuilderStateEnum,
        MV: 'MV' as BuilderStateEnum,
        NI: 'NI' as BuilderStateEnum,
        NW: 'NW' as BuilderStateEnum,
        RP: 'RP' as BuilderStateEnum,
        SL: 'SL' as BuilderStateEnum,
        SN: 'SN' as BuilderStateEnum,
        ST: 'ST' as BuilderStateEnum,
        SH: 'SH' as BuilderStateEnum,
        TH: 'TH' as BuilderStateEnum
    };
    export type BuilderCountryEnum = 'AND' | 'ARE' | 'AFG' | 'ATG' | 'AIA' | 'ALB' | 'ARM' | 'AGO' | 'ATA' | 'ARG' | 'ASM' | 'AUT' | 'AUS' | 'ABW' | 'ALA' | 'AZE' | 'BIH' | 'BRB' | 'BGD' | 'BEL' | 'BFA' | 'BGR' | 'BHR' | 'BDI' | 'BEN' | 'BLM' | 'BMU' | 'BRN' | 'BOL' | 'BES' | 'BRA' | 'BHS' | 'BTN' | 'BVT' | 'BWA' | 'BLR' | 'BLZ' | 'CAN' | 'CCK' | 'COD' | 'CAF' | 'COG' | 'CHE' | 'CIV' | 'COK' | 'CHL' | 'CMR' | 'CHN' | 'COL' | 'CRI' | 'CUB' | 'CPV' | 'CUW' | 'CXR' | 'CYP' | 'CZE' | 'DEU' | 'DJI' | 'DNK' | 'DMA' | 'DOM' | 'DZA' | 'ECU' | 'EST' | 'EGY' | 'ESH' | 'ERI' | 'ESP' | 'ETH' | 'FIN' | 'FJI' | 'FLK' | 'FSM' | 'FRO' | 'FRA' | 'GAB' | 'GBR' | 'GRD' | 'GEO' | 'GUF' | 'GGY' | 'GHA' | 'GIB' | 'GRL' | 'GMB' | 'GIN' | 'GLP' | 'GNQ' | 'GRC' | 'SGS' | 'GTM' | 'GUM' | 'GNB' | 'GUY' | 'HKG' | 'HMD' | 'HND' | 'HRV' | 'HTI' | 'HUN' | 'IDN' | 'IRL' | 'ISR' | 'IMN' | 'IND' | 'IOT' | 'IRQ' | 'IRN' | 'ISL' | 'ITA' | 'JEY' | 'JAM' | 'JOR' | 'JPN' | 'KEN' | 'KGZ' | 'KHM' | 'KIR' | 'COM' | 'KNA' | 'PRK' | 'KOR' | 'KWT' | 'CYM' | 'KAZ' | 'LAO' | 'LBN' | 'LCA' | 'LIE' | 'LKA' | 'LBR' | 'LSO' | 'LTU' | 'LUX' | 'LVA' | 'LBY' | 'MAR' | 'MCO' | 'MDA' | 'MNE' | 'MAF' | 'MDG' | 'MHL' | 'MKD' | 'MLI' | 'MMR' | 'MNG' | 'MAC' | 'MNP' | 'MTQ' | 'MRT' | 'MSR' | 'MLT' | 'MUS' | 'MDV' | 'MWI' | 'MEX' | 'MYS' | 'MOZ' | 'NAM' | 'NCL' | 'NER' | 'NFK' | 'NGA' | 'NIC' | 'NLD' | 'NOR' | 'NPL' | 'NRU' | 'NIU' | 'NZL' | 'OMN' | 'PAN' | 'PER' | 'PYF' | 'PNG' | 'PHL' | 'PAK' | 'POL' | 'SPM' | 'PCN' | 'PRI' | 'PSE' | 'PRT' | 'PLW' | 'PRY' | 'QAT' | 'REU' | 'ROU' | 'SRB' | 'RUS' | 'RWA' | 'SAU' | 'SLB' | 'SYC' | 'SDN' | 'SWE' | 'SGP' | 'SHN' | 'SVN' | 'SJM' | 'SVK' | 'SLE' | 'SMR' | 'SEN' | 'SOM' | 'SUR' | 'SSD' | 'STP' | 'SLV' | 'SXM' | 'SYR' | 'SWZ' | 'TCA' | 'TCD' | 'ATF' | 'TGO' | 'THA' | 'TJK' | 'TKL' | 'TLS' | 'TKM' | 'TUN' | 'TON' | 'TUR' | 'TTO' | 'TUV' | 'TWN' | 'TZA' | 'UKR' | 'UGA' | 'UMI' | 'USA' | 'URY' | 'UZB' | 'VAT' | 'VCT' | 'VEN' | 'VGB' | 'VIR' | 'VNM' | 'VUT' | 'WLF' | 'WSM' | 'YEM' | 'MYT' | 'ZAF' | 'ZMB' | 'ZWE';
    export const BuilderCountryEnum = {
        AND: 'AND' as BuilderCountryEnum,
        ARE: 'ARE' as BuilderCountryEnum,
        AFG: 'AFG' as BuilderCountryEnum,
        ATG: 'ATG' as BuilderCountryEnum,
        AIA: 'AIA' as BuilderCountryEnum,
        ALB: 'ALB' as BuilderCountryEnum,
        ARM: 'ARM' as BuilderCountryEnum,
        AGO: 'AGO' as BuilderCountryEnum,
        ATA: 'ATA' as BuilderCountryEnum,
        ARG: 'ARG' as BuilderCountryEnum,
        ASM: 'ASM' as BuilderCountryEnum,
        AUT: 'AUT' as BuilderCountryEnum,
        AUS: 'AUS' as BuilderCountryEnum,
        ABW: 'ABW' as BuilderCountryEnum,
        ALA: 'ALA' as BuilderCountryEnum,
        AZE: 'AZE' as BuilderCountryEnum,
        BIH: 'BIH' as BuilderCountryEnum,
        BRB: 'BRB' as BuilderCountryEnum,
        BGD: 'BGD' as BuilderCountryEnum,
        BEL: 'BEL' as BuilderCountryEnum,
        BFA: 'BFA' as BuilderCountryEnum,
        BGR: 'BGR' as BuilderCountryEnum,
        BHR: 'BHR' as BuilderCountryEnum,
        BDI: 'BDI' as BuilderCountryEnum,
        BEN: 'BEN' as BuilderCountryEnum,
        BLM: 'BLM' as BuilderCountryEnum,
        BMU: 'BMU' as BuilderCountryEnum,
        BRN: 'BRN' as BuilderCountryEnum,
        BOL: 'BOL' as BuilderCountryEnum,
        BES: 'BES' as BuilderCountryEnum,
        BRA: 'BRA' as BuilderCountryEnum,
        BHS: 'BHS' as BuilderCountryEnum,
        BTN: 'BTN' as BuilderCountryEnum,
        BVT: 'BVT' as BuilderCountryEnum,
        BWA: 'BWA' as BuilderCountryEnum,
        BLR: 'BLR' as BuilderCountryEnum,
        BLZ: 'BLZ' as BuilderCountryEnum,
        CAN: 'CAN' as BuilderCountryEnum,
        CCK: 'CCK' as BuilderCountryEnum,
        COD: 'COD' as BuilderCountryEnum,
        CAF: 'CAF' as BuilderCountryEnum,
        COG: 'COG' as BuilderCountryEnum,
        CHE: 'CHE' as BuilderCountryEnum,
        CIV: 'CIV' as BuilderCountryEnum,
        COK: 'COK' as BuilderCountryEnum,
        CHL: 'CHL' as BuilderCountryEnum,
        CMR: 'CMR' as BuilderCountryEnum,
        CHN: 'CHN' as BuilderCountryEnum,
        COL: 'COL' as BuilderCountryEnum,
        CRI: 'CRI' as BuilderCountryEnum,
        CUB: 'CUB' as BuilderCountryEnum,
        CPV: 'CPV' as BuilderCountryEnum,
        CUW: 'CUW' as BuilderCountryEnum,
        CXR: 'CXR' as BuilderCountryEnum,
        CYP: 'CYP' as BuilderCountryEnum,
        CZE: 'CZE' as BuilderCountryEnum,
        DEU: 'DEU' as BuilderCountryEnum,
        DJI: 'DJI' as BuilderCountryEnum,
        DNK: 'DNK' as BuilderCountryEnum,
        DMA: 'DMA' as BuilderCountryEnum,
        DOM: 'DOM' as BuilderCountryEnum,
        DZA: 'DZA' as BuilderCountryEnum,
        ECU: 'ECU' as BuilderCountryEnum,
        EST: 'EST' as BuilderCountryEnum,
        EGY: 'EGY' as BuilderCountryEnum,
        ESH: 'ESH' as BuilderCountryEnum,
        ERI: 'ERI' as BuilderCountryEnum,
        ESP: 'ESP' as BuilderCountryEnum,
        ETH: 'ETH' as BuilderCountryEnum,
        FIN: 'FIN' as BuilderCountryEnum,
        FJI: 'FJI' as BuilderCountryEnum,
        FLK: 'FLK' as BuilderCountryEnum,
        FSM: 'FSM' as BuilderCountryEnum,
        FRO: 'FRO' as BuilderCountryEnum,
        FRA: 'FRA' as BuilderCountryEnum,
        GAB: 'GAB' as BuilderCountryEnum,
        GBR: 'GBR' as BuilderCountryEnum,
        GRD: 'GRD' as BuilderCountryEnum,
        GEO: 'GEO' as BuilderCountryEnum,
        GUF: 'GUF' as BuilderCountryEnum,
        GGY: 'GGY' as BuilderCountryEnum,
        GHA: 'GHA' as BuilderCountryEnum,
        GIB: 'GIB' as BuilderCountryEnum,
        GRL: 'GRL' as BuilderCountryEnum,
        GMB: 'GMB' as BuilderCountryEnum,
        GIN: 'GIN' as BuilderCountryEnum,
        GLP: 'GLP' as BuilderCountryEnum,
        GNQ: 'GNQ' as BuilderCountryEnum,
        GRC: 'GRC' as BuilderCountryEnum,
        SGS: 'SGS' as BuilderCountryEnum,
        GTM: 'GTM' as BuilderCountryEnum,
        GUM: 'GUM' as BuilderCountryEnum,
        GNB: 'GNB' as BuilderCountryEnum,
        GUY: 'GUY' as BuilderCountryEnum,
        HKG: 'HKG' as BuilderCountryEnum,
        HMD: 'HMD' as BuilderCountryEnum,
        HND: 'HND' as BuilderCountryEnum,
        HRV: 'HRV' as BuilderCountryEnum,
        HTI: 'HTI' as BuilderCountryEnum,
        HUN: 'HUN' as BuilderCountryEnum,
        IDN: 'IDN' as BuilderCountryEnum,
        IRL: 'IRL' as BuilderCountryEnum,
        ISR: 'ISR' as BuilderCountryEnum,
        IMN: 'IMN' as BuilderCountryEnum,
        IND: 'IND' as BuilderCountryEnum,
        IOT: 'IOT' as BuilderCountryEnum,
        IRQ: 'IRQ' as BuilderCountryEnum,
        IRN: 'IRN' as BuilderCountryEnum,
        ISL: 'ISL' as BuilderCountryEnum,
        ITA: 'ITA' as BuilderCountryEnum,
        JEY: 'JEY' as BuilderCountryEnum,
        JAM: 'JAM' as BuilderCountryEnum,
        JOR: 'JOR' as BuilderCountryEnum,
        JPN: 'JPN' as BuilderCountryEnum,
        KEN: 'KEN' as BuilderCountryEnum,
        KGZ: 'KGZ' as BuilderCountryEnum,
        KHM: 'KHM' as BuilderCountryEnum,
        KIR: 'KIR' as BuilderCountryEnum,
        COM: 'COM' as BuilderCountryEnum,
        KNA: 'KNA' as BuilderCountryEnum,
        PRK: 'PRK' as BuilderCountryEnum,
        KOR: 'KOR' as BuilderCountryEnum,
        KWT: 'KWT' as BuilderCountryEnum,
        CYM: 'CYM' as BuilderCountryEnum,
        KAZ: 'KAZ' as BuilderCountryEnum,
        LAO: 'LAO' as BuilderCountryEnum,
        LBN: 'LBN' as BuilderCountryEnum,
        LCA: 'LCA' as BuilderCountryEnum,
        LIE: 'LIE' as BuilderCountryEnum,
        LKA: 'LKA' as BuilderCountryEnum,
        LBR: 'LBR' as BuilderCountryEnum,
        LSO: 'LSO' as BuilderCountryEnum,
        LTU: 'LTU' as BuilderCountryEnum,
        LUX: 'LUX' as BuilderCountryEnum,
        LVA: 'LVA' as BuilderCountryEnum,
        LBY: 'LBY' as BuilderCountryEnum,
        MAR: 'MAR' as BuilderCountryEnum,
        MCO: 'MCO' as BuilderCountryEnum,
        MDA: 'MDA' as BuilderCountryEnum,
        MNE: 'MNE' as BuilderCountryEnum,
        MAF: 'MAF' as BuilderCountryEnum,
        MDG: 'MDG' as BuilderCountryEnum,
        MHL: 'MHL' as BuilderCountryEnum,
        MKD: 'MKD' as BuilderCountryEnum,
        MLI: 'MLI' as BuilderCountryEnum,
        MMR: 'MMR' as BuilderCountryEnum,
        MNG: 'MNG' as BuilderCountryEnum,
        MAC: 'MAC' as BuilderCountryEnum,
        MNP: 'MNP' as BuilderCountryEnum,
        MTQ: 'MTQ' as BuilderCountryEnum,
        MRT: 'MRT' as BuilderCountryEnum,
        MSR: 'MSR' as BuilderCountryEnum,
        MLT: 'MLT' as BuilderCountryEnum,
        MUS: 'MUS' as BuilderCountryEnum,
        MDV: 'MDV' as BuilderCountryEnum,
        MWI: 'MWI' as BuilderCountryEnum,
        MEX: 'MEX' as BuilderCountryEnum,
        MYS: 'MYS' as BuilderCountryEnum,
        MOZ: 'MOZ' as BuilderCountryEnum,
        NAM: 'NAM' as BuilderCountryEnum,
        NCL: 'NCL' as BuilderCountryEnum,
        NER: 'NER' as BuilderCountryEnum,
        NFK: 'NFK' as BuilderCountryEnum,
        NGA: 'NGA' as BuilderCountryEnum,
        NIC: 'NIC' as BuilderCountryEnum,
        NLD: 'NLD' as BuilderCountryEnum,
        NOR: 'NOR' as BuilderCountryEnum,
        NPL: 'NPL' as BuilderCountryEnum,
        NRU: 'NRU' as BuilderCountryEnum,
        NIU: 'NIU' as BuilderCountryEnum,
        NZL: 'NZL' as BuilderCountryEnum,
        OMN: 'OMN' as BuilderCountryEnum,
        PAN: 'PAN' as BuilderCountryEnum,
        PER: 'PER' as BuilderCountryEnum,
        PYF: 'PYF' as BuilderCountryEnum,
        PNG: 'PNG' as BuilderCountryEnum,
        PHL: 'PHL' as BuilderCountryEnum,
        PAK: 'PAK' as BuilderCountryEnum,
        POL: 'POL' as BuilderCountryEnum,
        SPM: 'SPM' as BuilderCountryEnum,
        PCN: 'PCN' as BuilderCountryEnum,
        PRI: 'PRI' as BuilderCountryEnum,
        PSE: 'PSE' as BuilderCountryEnum,
        PRT: 'PRT' as BuilderCountryEnum,
        PLW: 'PLW' as BuilderCountryEnum,
        PRY: 'PRY' as BuilderCountryEnum,
        QAT: 'QAT' as BuilderCountryEnum,
        REU: 'REU' as BuilderCountryEnum,
        ROU: 'ROU' as BuilderCountryEnum,
        SRB: 'SRB' as BuilderCountryEnum,
        RUS: 'RUS' as BuilderCountryEnum,
        RWA: 'RWA' as BuilderCountryEnum,
        SAU: 'SAU' as BuilderCountryEnum,
        SLB: 'SLB' as BuilderCountryEnum,
        SYC: 'SYC' as BuilderCountryEnum,
        SDN: 'SDN' as BuilderCountryEnum,
        SWE: 'SWE' as BuilderCountryEnum,
        SGP: 'SGP' as BuilderCountryEnum,
        SHN: 'SHN' as BuilderCountryEnum,
        SVN: 'SVN' as BuilderCountryEnum,
        SJM: 'SJM' as BuilderCountryEnum,
        SVK: 'SVK' as BuilderCountryEnum,
        SLE: 'SLE' as BuilderCountryEnum,
        SMR: 'SMR' as BuilderCountryEnum,
        SEN: 'SEN' as BuilderCountryEnum,
        SOM: 'SOM' as BuilderCountryEnum,
        SUR: 'SUR' as BuilderCountryEnum,
        SSD: 'SSD' as BuilderCountryEnum,
        STP: 'STP' as BuilderCountryEnum,
        SLV: 'SLV' as BuilderCountryEnum,
        SXM: 'SXM' as BuilderCountryEnum,
        SYR: 'SYR' as BuilderCountryEnum,
        SWZ: 'SWZ' as BuilderCountryEnum,
        TCA: 'TCA' as BuilderCountryEnum,
        TCD: 'TCD' as BuilderCountryEnum,
        ATF: 'ATF' as BuilderCountryEnum,
        TGO: 'TGO' as BuilderCountryEnum,
        THA: 'THA' as BuilderCountryEnum,
        TJK: 'TJK' as BuilderCountryEnum,
        TKL: 'TKL' as BuilderCountryEnum,
        TLS: 'TLS' as BuilderCountryEnum,
        TKM: 'TKM' as BuilderCountryEnum,
        TUN: 'TUN' as BuilderCountryEnum,
        TON: 'TON' as BuilderCountryEnum,
        TUR: 'TUR' as BuilderCountryEnum,
        TTO: 'TTO' as BuilderCountryEnum,
        TUV: 'TUV' as BuilderCountryEnum,
        TWN: 'TWN' as BuilderCountryEnum,
        TZA: 'TZA' as BuilderCountryEnum,
        UKR: 'UKR' as BuilderCountryEnum,
        UGA: 'UGA' as BuilderCountryEnum,
        UMI: 'UMI' as BuilderCountryEnum,
        USA: 'USA' as BuilderCountryEnum,
        URY: 'URY' as BuilderCountryEnum,
        UZB: 'UZB' as BuilderCountryEnum,
        VAT: 'VAT' as BuilderCountryEnum,
        VCT: 'VCT' as BuilderCountryEnum,
        VEN: 'VEN' as BuilderCountryEnum,
        VGB: 'VGB' as BuilderCountryEnum,
        VIR: 'VIR' as BuilderCountryEnum,
        VNM: 'VNM' as BuilderCountryEnum,
        VUT: 'VUT' as BuilderCountryEnum,
        WLF: 'WLF' as BuilderCountryEnum,
        WSM: 'WSM' as BuilderCountryEnum,
        YEM: 'YEM' as BuilderCountryEnum,
        MYT: 'MYT' as BuilderCountryEnum,
        ZAF: 'ZAF' as BuilderCountryEnum,
        ZMB: 'ZMB' as BuilderCountryEnum,
        ZWE: 'ZWE' as BuilderCountryEnum
    };
}